export function flattenMaterialGroups(data) {
    return (Array.isArray(data) ? data : []).flatMap((group) => {
        if (!group || typeof group !== "object") return [];
        if (!Array.isArray(group.data)) return [];
        return group.data
            .filter((row) => row && typeof row === "object" && !Array.isArray(row))
            .map((row) => ({ ...row, Material_ID: group.Material_ID }));
    });
}

export function buildMaterialDisplayRows(rows, grouped) {
    if (!grouped) return rows.map((row) => ({ row }));
    const groups = new Map();
    rows.forEach((row) => {
        const materialId = row.Material_ID ?? "-";
        if (!groups.has(materialId)) groups.set(materialId, []);
        groups.get(materialId).push(row);
    });
    return [...groups].flatMap(([materialId, groupRows]) =>
        groupRows.map((row, index) => ({ row, materialId, showHeader: index === 0 })),
    );
}